import React from "react";
import tw from "twin.macro";

const CollabContainer = tw.div`lg:w-8/12 xl:w-6/12 mx-auto text-2xl text-center leading-tight my-12`;
const RedText = tw.strong`text-red-900 font-bold`;
const BlueText = tw.strong`text-blue-900 font-bold`;

const Collaboration = () => (
  <CollabContainer>
    The DMACC is a collaboration between the{" "}
    <RedText>University of Wisconsin</RedText> School of Medicine and Public
    Health and <BlueText>Frontier Science Foundation</BlueText>
  </CollabContainer>
);

export default Collaboration;
